"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.prepareDate = void 0;
const constants_1 = require("@pulse-web-platform-core/constants");
const date_fns_1 = require("date-fns");
const date_fns_tz_1 = require("date-fns-tz");
const prepareDate = (date) => {
    if (date instanceof Date) {
        const roundedDate = (0, date_fns_1.startOfDay)(date);
        const formattedDate = (0, date_fns_tz_1.format)(roundedDate, "yyyy-MM-dd'T'HH:mm:ss.SSSXXX", {
            timeZone: constants_1.TIME_ZONE_MOSCOW,
        });
        return formattedDate;
    }
    return '';
};
exports.prepareDate = prepareDate;
